import { isTabletApp } from 'utility/Check/Device';
import {
    getC24App,
    getCheck24Wireframe,
} from 'utility/Provide/Namespace/getCheck24Namespace';
import {
    isCurrentRoutePartOfString,
    isPartOfRouteSet,
    isTravelBookingAll,
} from 'utility/Provide/Route/isCurrentRoutePartOfString';
import { RouteType } from 'utility/Provide/Route/types';

import { ChattyClientDetailOfferParams } from 'types/chatty/offerParams';
import { ChattyConfig, Check24Wireframe } from 'types/legacy/wireframe';

import { bridgeConfig } from '../__config/settings';

export const getChatBotConfig = (
    chattyConfig: ChattyConfig,
    serviceCode: string,
    offerData?: ChattyClientDetailOfferParams
) => {
    const Check24 = getCheck24Wireframe();
    const holdingRoutes = new Set([
        RouteType.GOLDCLUBLANDINGPAGE,
        RouteType.VOUCHER_APP,
        RouteType.VOUCHER,
        RouteType.POINTS_PROMOTION_TERMS,
        RouteType.POINTS_PROMOTION,
    ]);
    const isHoldingChatbot = isPartOfRouteSet(holdingRoutes);
    const defaultClientDetails = isHoldingChatbot
        ? {}
        : {
              connectionInfoDetails: {
                  serviceCode: serviceCode,
                  pageScope: getPageScope(),
                  plugin: bridgeConfig.plugin,
              },
          };
    const clientDetails =
        !!offerData && !!defaultClientDetails.connectionInfoDetails
            ? {
                  ...defaultClientDetails,
                  connectionInfoDetails: {
                      ...defaultClientDetails.connectionInfoDetails,
                      offer: offerData,
                  },
              }
            : defaultClientDetails;
    const mainConfig: ChattyConfig = {
        ...chattyConfig,
        deviceoutput: 'desktop',
        chatbot: {
            ...chattyConfig.chatbot,
            deviceoutput: 'desktop',
            client: {
                ...chattyConfig.chatbot?.client,
                clientDetails: clientDetails,
            },
        },
    };

    if (isTabletApp() && !!Check24) {
        tabletAppHandling(Check24, mainConfig);
    }

    return mainConfig;
};

export const getPageScope = () => {
    const isCsiOpen = document.body.classList.contains('csi-open');
    if (isCurrentRoutePartOfString(RouteType.TRAVELSEARCH_REGION)) {
        return 2;
    } else if (isCurrentRoutePartOfString(RouteType.TRAVELSEARCH_HOTEL)) {
        return 3;
    } else if (
        isCurrentRoutePartOfString(RouteType.TRAVELSEARCH_OFFER) &&
        !isCsiOpen
    ) {
        return 4;
    } else if (
        isTravelBookingAll() ||
        (isCurrentRoutePartOfString(RouteType.TRAVELSEARCH_OFFER) && isCsiOpen)
    ) {
        return 5;
    }

    return 1;
};
export const getServiceCode = () => {
    const serviceCodeElement = document.querySelector('.js-service-code-code');

    return serviceCodeElement?.textContent || '';
};
const tabletAppHandling = (
    Check24: Check24Wireframe,
    mainConfig: ChattyConfig
) => {
    const C24App = getC24App();

    Check24.loader.useChatbotApp = true;
    if (C24App.isAndroidBridgeAvailable() || C24App.isiOSBridgeAvailable()) {
        C24App.setSupportDialogHandler(function () {
            Check24.loader.openChatbot(mainConfig);

            return true; //important, otherwise core would trigger a holding dialog
        });
    }
};
